export default __webpack_public_path__ + "static/media/screen-share-ild.f7c787c6.png";